import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from "@angular/fire/auth"
import { Observable } from 'rxjs/internal/Observable';
import { map } from "rxjs/operators"

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
    constructor(
        private router: Router,
        private auth: AngularFireAuth,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.auth.authState.pipe(
            map(user => {
                if (user != null) {
                    return true
                } else {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return false
                }
            })
        )
    }
}